exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_image[data-v-23c94f9b]{width:275px;text-align:center;margin:0 auto}.box_text[data-v-23c94f9b]{color:#fff;font-size:18px;text-align:center;margin:15px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23c94f9b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Notification.vue
// module id = 57
// module chunks = 0